'use strict';

// Constructor
var Apps = function() {

	// Apps toggle from 5 default elements displayed to complete list
	$('.allapps,.card_applications .viewall').on('click', function(e){
		e.preventDefault();
		$('.card_applications').toggleClass('expanded');

		if($('.card_applications').hasClass('expanded')){
			//$('.allapps').text('Collapse Applications');
			$('.allapps, .card_applications .viewall').text('Hide');
		} else {
			//$('.allapps').text('View all Applications');
			$('.allapps, .card_applications .viewall').text('View More');
			$('html, body').animate({
				scrollTop: $('.card_applications').offset().top
			}, 500);
		}
	});

	//Tooltip
	$('.tooltip').on('click', function(e){
		e.preventDefault();
	});

}

module.exports = Apps;
